import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import {
  Checkbox,
  FormControlLabel,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableRow
} from '@material-ui/core';
import CancelButton from '../atoms/CancelButton';
import ChangeButton from '../atoms/ChangeButton';
import RequiredButton from '../atoms/RequiredButton';
import ValidationText from '../atoms/ValidationText';

const styles = {
  titleModal: {
    fontWeight: 700,
    fontSize: '20px',
    lineHeight: '140%',
    marginBottom: 16
  },
  header: {
    fontSize: 18,
    fontWeight: 700
  },
  mainPaper: {
    minWidth: 400
  },
  dialogActionLeft: {
    justifyContent: 'flex-start'
  },
  noBorder: {
    border: 'none'
  },
  padding8: {
    padding: 8
  },
  radioBox: {
    padding: '8px 24px'
  },
  checkboxContainer: {
    display: 'flex',
    alignItems: 'center',
    margin: '4px 8px 4px 0'
  },
  listSystem: {
    maxHeight: 360,
    overflowY: 'auto'
  },
  bodyModal: {
    maxWidth: 470
  },
  error: {
    marginTop: 16
  }
};

const enhance = compose();

const Main = enhance(
  ({
    classes,
    openChange,
    cancelAction,
    openConfirmAction,
    allSystem,
    setAllSystem,
    systems,
    fromSystemIds,
    setFromSystemIds,
    chooseSystemError
  }) => {
    return (
      <>
        <Dialog
          open={openChange}
          onClose={cancelAction}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent className={classes.bodyModal}>
            <Typography component="p" className={classes.titleModal}>
              お知らせ配信
            </Typography>
            <Paper className={classes.mainPaper} elevation={1}>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell className={classes.noBorder}>
                      <RequiredButton />
                    </TableCell>
                    <TableCell className={[classes.noBorder, classes.radioBox]}>
                      <Typography className={classes.header}>配信先</Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.noBorder} />
                    <TableCell className={[classes.noBorder, classes.radioBox]}>
                      <RadioGroup
                        value={allSystem}
                        onChange={e => {
                          const allowed = parseInt(e.target.value, 10);
                          setAllSystem(allowed);
                        }}
                        className={classes.radioGroup}
                      >
                        <div>
                          <FormControlLabel
                            value={0}
                            control={<Radio color="primary" />}
                            label="特定の法人のみ"
                          />
                          <FormControlLabel
                            value={1}
                            control={<Radio color="primary" />}
                            label="全ての法人"
                          />
                        </div>
                      </RadioGroup>
                    </TableCell>
                  </TableRow>
                  {!allSystem && (
                    <TableRow>
                      <TableCell className={classes.padding8} />
                      <TableCell className={classes.padding8}>
                        <div className={classes.listSystem}>
                          {systems.map(system => (
                            <div className={classes.checkboxContainer}>
                              <Checkbox
                                color="primary"
                                checked={fromSystemIds.includes(
                                  system.connectSystemId
                                )}
                                onChange={event => {
                                  if (event.target.checked) {
                                    setFromSystemIds([
                                      ...fromSystemIds,
                                      system.connectSystemId
                                    ]);
                                  } else {
                                    setFromSystemIds(
                                      fromSystemIds.filter(
                                        item => item !== system.connectSystemId
                                      )
                                    );
                                  }
                                }}
                              />
                              <Typography>
                                {system.connectSystemName}
                              </Typography>
                            </div>
                          ))}
                        </div>
                        <ValidationText
                          classes={classes}
                          message={chooseSystemError}
                        />
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </Paper>
          </DialogContent>
          <DialogActions className={classes.dialogActionLeft}>
            <CancelButton color="primary" onClickAction={cancelAction} />
            <ChangeButton
              onClickAction={openConfirmAction}
              btnText="内容入力へ"
            />
          </DialogActions>
        </Dialog>
      </>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
